import { type ExperienceMultiSurveyCardReasonSection } from '@bbkAdminRedux/rtkq/experience.slice';
import {
  SurveyType,
  type RestMultiRowSurveyCard,
} from '@bbkAdminUtils/api-client/rest-cards-types';

export default function isReasonOther(reasonKey: string): boolean {
  const reasonOtherRegex = /^(?:other_reason|other(\.\d+|_\d+)?)$/g;
  return reasonOtherRegex.test(reasonKey);
}

export const findSelectedReason = (
  surveyType: SurveyType | '',
  response: Partial<RestMultiRowSurveyCard['provides']>,
  questions: RestMultiRowSurveyCard['requires']['multi_row_survey']
): { label: string } => {
  if (surveyType === SurveyType.multi_row_survey) {
    const lastReasonPicked = response.reason_for_leaving?.find(
      (reason) => reason.tier === 'tier0'
    );
    if (!lastReasonPicked) return { label: 'No reason given.' };
    const chosenQuestionGroup = questions.find(
      (q) => q.name === lastReasonPicked.name
    ) as ExperienceMultiSurveyCardReasonSection;
    const result = chosenQuestionGroup.options.find(
      (option) => option.value === lastReasonPicked.value
    );
    return result ?? { label: 'No reason given.' };
  }
  return { label: 'No reason given.' };
};
